import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AdminRoutes from './Admin/App';

import Navbar from "./components/Navbar";
import Home from "./components/pages/Home";
import Login from "./components/pages/Login";
import Register from "./components/pages/Register";
import Footer from "./components/Footer";
import ServiceDetail from "./components/pages/ServiceDetail";
import Search from "./components/pages/Search";
// import Profile from "./components/pages/Profile";
import Profile from './components/pages/Profile';
import Wallet from './components/pages/Wallet';
import Cart from "./components/Cart";
import BookingHistory from "./components/pages/BookingHistory";
import Checkout from "./components/pages/Checkout";
import BookingList from "./components/pages/BookingList";
import JoinUs from "./components/pages/JoinUs";
import Notification from "./components/pages/Notification";
import AllNotification from "./components/pages/AllNotifications";
import Tracking from "./components/pages/Tracking";
import AboutUs from "./components/pages/AboutUs";
import ContactUs from "./components/pages/ContactUs";
import whatsapp from "./assets/icons8-whatsapp-480.png";
import { ChevronsUp } from "lucide-react";
import { useEffect, useState } from "react";
import ApiProvider from "src/context/ApiContext.jsx"; // Import ApiProvider


import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotificationHandler from './components/NotificationHandler';
import { onMessageListener } from "./services/firebase";
import CallerScreen from "./components/pages/CallerScreen";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermsAndConditions from "./components/pages/TermsAndConditions";
import Disclaimer from "./components/pages/Disclaimer";
// import TempoTraveller from "./components/pages/TempoTraveller";
// import TravelBookings from "./components/pages/TravelBookings";
// import TravelBookingHistory from "./components/pages/TravelBookings";
import LiveTracking from "./components/LiveTracking";
import Subcategory from "./components/pages/Subcategory";
import Service from "./components/pages/Service";
import PaymentSuccess from "./components/PaymentSuccess";

const phoneNumber = "919900006581"; // Added India country code (91)
const defaultMessage = "Hello Wave Tech Services, I have a question about...";

// Properly encode the message
const encodedMessage = encodeURIComponent(defaultMessage);
const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

const ChatIcon = ({ onClick }) => (

  // <div className="fixed z-50 p-0 rounded-full cursor-pointer right-1 bottom-20 hover:scale-105"

  // >
  //   <a href="https://wa.me/9900006581?text=How May I Help You?" target="_blank"">
  //     <img src={whatsapp} alt="Chat Icon" className="w-10" />
  //   </a>
  // </div> 
  <div className="fixed z-50 p-0 rounded-full cursor-pointer right-1 bottom-20 hover:scale-105">
    <a
      href={whatsappUrl}
      target="_blank"
    // rel="noopener noreferrer"
    // className="block p-0 rounded-full cursor-pointer transition-transform duration-200 hover:scale-105"
    // aria-label="Chat with us on WhatsApp"
    >
      <img
        src={whatsapp}
        alt="WhatsApp Chat"
        className="size-10" // Slightly larger for better clickability
      />
    </a>
  </div>
);

const ScrollToTopIcon = ({ onClick }) => (
  <div
    className="fixed z-50 p-0 rounded-full cursor-pointer right-2 bottom-10 hover:scale-105"
    onClick={onClick}
  >
    <div className="gradient p-1 rounded-full">
      <ChevronsUp className="text-gradient text-white" />
    </div>
  </div>
);

function App() {
  const [showIcons, setShowIcons] = useState(false);
  const [showChatApp, setShowChatApp] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowIcons(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then(registration => {
          console.log('Service Worker registered:', registration);
        })
        .catch(err => {
          console.log('Service Worker registration failed:', err);
        });
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const chatBot = () => {
    setShowChatApp(!showChatApp);
  };

  const userId = localStorage.getItem("userId")

  // Setup message listener
  useEffect(() => {
    const setupMessageListener = async () => {
      try {
        const payload = await onMessageListener();
        if (payload) {
          toast.info(payload.notification.body, {
            position: "top-right",
            autoClose: 5000,
          });

          // Update app state if needed
          // dispatch(updateNotifications(payload.data));
        }
      } catch (error) {
        console.error('Message listener error:', error);
      }
    };

    setupMessageListener();
  }, []);

  return (
    <ApiProvider>
      {" "}
      {/* Wrap the entire app with ApiProvider */}

      <BrowserRouter>
        {showIcons && (
          <>
            <ChatIcon onClick={chatBot} />
            <ScrollToTopIcon onClick={scrollToTop} />
          </>
        )}
        <div className="App">
          <ToastContainer />
          <NotificationHandler userId={userId} />
          {/* Your other components */}
        </div>
        <Notification />

        <Routes>
          <Route
            path="/"
            element={
              <>
                <Navbar />
                <Home />

                <Footer />
              </>
            }
          />
          <Route path="/login" element={<Login />} />

          <Route path="/call" element={<CallerScreen />} />
          <Route path="/LiveTracking" element={<LiveTracking />} />
          <Route path="/privacy" element={
            <>
              <Navbar />
              <PrivacyPolicy />
              <Footer />
            </>
          } />
          <Route path="/terms" element={
            <>
              <Navbar />
              <TermsAndConditions />
              <Footer />
            </>
          } />
          <Route path="/disclaimer" element={
            <>
              <Navbar />
              <Disclaimer />
              <Footer />
            </>
          } />
          <Route path="/wallet" element={
            <>
              <Navbar />
              <Wallet />
              <Footer />
            </>
          } />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={
            <>
              <Navbar />
              <Profile />
              <Footer />
            </>
          } />
          <Route
            path="/service_details"
            element={
              <>
                <Navbar />
                <ServiceDetail />
                <Footer />
              </>
            }
          />
          <Route
            path="/search"
            element={
              <>
                <Navbar />
                <Search />
                <Footer />
              </>
            }
          />
          <Route
            path="/subcategory"
            element={
              <>
                <Navbar />
                <Subcategory />
                <Footer />
              </>
            }
          />
          <Route
            path="/service"
            element={
              <>
                <Navbar />
                <Service />
                <Footer />
              </>
            }
          />
          {/* <Route
            path="/travelbooking"
            element={
              <>
                <Navbar />
                <TempoTraveller/>
                <Footer />
              </>
            }
          /> */}
          {/* <Route
            path="/BookingHistory"
            element={
              <>
                <Navbar />
                <BookingHistory />
                <Footer />
              </>
            }
          /> */}
          {/* <Route
            path="/cart"
            element={
              <>
                <Navbar />
                <Cart />
                <Footer />
              </>
            }
          /> */}
          <Route path="/checkout" element={<Checkout />} />
          <Route
            path="/booking_list"
            element={
              <>
                <Navbar />
                {/* <BookingList /> */}
                <BookingHistory />
                <Footer />
              </>
            }
          />
          {/* <Route
            path="/travelhistory"
            element={
              <>
                <Navbar /> 
                <TravelBookingHistory/>
                <Footer />
              </>
            }
          /> */}
          <Route
            path="/join_us"
            element={
              <>
                <Navbar />
                <JoinUs />
                <Footer />
              </>
            }
          />
          <Route
            path="/payment-success"
            element={
              <>
                <Navbar />
                <PaymentSuccess />
                <Footer />
              </>
            }
          />
          <Route
            path="/notification"
            element={
              <>
                <Navbar />
                <AllNotification />
                <Footer />
              </>
            }
          />
          <Route
            path="/all-notifications"
            element={
              <>
                <Navbar />
                <AllNotification />
                <Footer />
              </>
            }
          />
          {/* <Route
            path="/tracking"
            element={
              <>
                <Navbar />
                <Tracking />
                <Footer />
              </>
            }
          />
           */}
          <Route
            path="/about_us"
            element={
              <>
                <Navbar />
                <AboutUs />
                <Footer />
              </>
            }
          />
          <Route
            path="/contact_us"
            element={
              <>
                <Navbar />
                <ContactUs />
                <Footer />
              </>
            }
          />
          <Route path="/admin/*" element={<AdminRoutes />} />
        </Routes>
      </BrowserRouter>
    </ApiProvider>
  );
}

export default App;
